function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();

  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch (error) {
    copied = false;
  }
  textArea.remove();

  return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-copy-link]');
  if (!button) return;

  const status = button.querySelector('[data-copy-link-status]');
  copyText(button.dataset.copyLink).then(
    () => {
      button.setAttribute('aria-label', 'Link copied');
      button.setAttribute('title', 'Link copied');
      if (status) status.textContent = 'Link copied';

      setTimeout(() => {
        button.setAttribute('aria-label', 'Copy link');
        button.setAttribute('title', 'Copy link');
        if (status) status.textContent = '';
      }, 2000);
    },
    () => {
      button.setAttribute('aria-label', 'Copy link failed');
      button.setAttribute('title', 'Copy link failed');
      if (status) status.textContent = 'Could not copy link';
    }
  );
});
